export enum SlideBuilderSectionLayoutType {
  DEFAULT = 'default',
  GRID = 'grid'
}
